import { render, staticRenderFns } from "./DashboardModalSave.vue?vue&type=template&id=433343ca&"
import script from "./DashboardModalSave.vue?vue&type=script&lang=js&"
export * from "./DashboardModalSave.vue?vue&type=script&lang=js&"
import style0 from "./DashboardModalSave.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports